import { Link as RouterLink, useLocation } from "react-router-dom";
import { useLang } from "../i18n/LangContext";

/** Persistent footer on content pages (not the map). Keeps the feedback
 *  channel one click away from every blog post / static page, and links
 *  back to the Imprint. The map route hides it because the footer would
 *  push the floating chrome out of the viewport. */
export function Footer() {
  const { t } = useLang();
  const location = useLocation();
  if (location.pathname === "/map" || location.pathname.startsWith("/spot/")) {
    return null;
  }

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <span className="site-footer__title">Fishing Iceland</span>
          <span className="site-footer__sub">
            Ein Hobbyprojekt von Moritz Habegger
          </span>
        </div>
        <nav className="site-footer__nav" aria-label="Footer">
          <RouterLink to="/impressum">{t("navImpressum")}</RouterLink>
          <RouterLink to="/blog">{t("navBlog")}</RouterLink>
          <a href="mailto:hi@fishing-iceland.app?subject=Feedback%20Fishing%20Iceland">
            {t("feedbackLink")}
          </a>
        </nav>
      </div>
    </footer>
  );
}
